import assign from 'object-assign';

import { KR_ADD_REQUEST, KR_ADD_SUCCESS, KR_ADD_FAILURE } from '../../action/okr_manage/kr';
import { KR_UPDATE_REQUEST, KR_UPDATE_SUCCESS, KR_UPDATE_FAILURE } from '../../action/okr_manage/kr';
import { KR_DELETE_REQUEST, KR_DELETE_SUCCESS, KR_DELETE_FAILURE } from '../../action/okr_manage/kr';

function okrKR(state = {}, action) {
  switch (action.type) {
    //人员数据
    case KR_ADD_REQUEST:
      return assign({}, state, { showLoading: true });
    case KR_ADD_SUCCESS:
      return assign({}, state, {
        showLoading: false
      })
    case KR_ADD_FAILURE:
      return assign({}, state, { showLoading: false });

    case KR_UPDATE_REQUEST:
      return assign({}, state, { showLoading: true });
    case KR_UPDATE_SUCCESS:
      return assign({}, state, {
        showLoading: false
      })
    case KR_DELETE_REQUEST:
      return assign({}, state, { showLoading: false });
    case KR_DELETE_SUCCESS:
      return assign({}, state, { showLoading: true });
    case KR_DELETE_FAILURE:
      return assign({}, state, {
        showLoading: false
      })
    case KR_UPDATE_FAILURE:
      return assign({}, state, { showLoading: false });
    default:
      return state;
  }
}

export default okrKR;




// WEBPACK FOOTER //
// ./src/reducer/okr_manage/okr_kr.js